import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useChartPointNavigation() {
    const navigate = useNavigate();

    return useCallback(
        (
            route: string,
            identifierParams: Record<string, string>,
            startTime: number,
            endTime: number,
        ) => {
            const params = new URLSearchParams(identifierParams);
            params.set('startTime', startTime.toString());
            params.set('endTime', endTime.toString());
            navigate(`${route}?${params.toString()}`);
        },
        [navigate],
    );
}
